import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {
  getSearchDialogue,
  getTranslations,
  searchAsyncActions
} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import DefaultIcon from 'assets/image/common/default.png';
import {Link, useParams} from 'react-router-dom';

import './styles.scss';

export const SearchChat: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    searchDialogue
  } = useSelector((state: IStore) => state.search);
  const dispatch = useDispatch();
  const {dialogueId} = useParams();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogueId) {
      dispatch(searchAsyncActions[getSearchDialogue](Number(dialogueId)));
    }
  }, [dialogueId]);

  useGetTranslations({
    translationKey: TranslationKeys.Chat
  });

  function renderBreadcrumbs() {
    return <div className="breadcrumbs">
      <Link className="breadcrumbs__previous" to="/search">
        <FormattedMessage
          id={'gritx.search.breadcrumb.previous'}
          defaultMessage="Search"
        />
      </Link> {searchDialogue && <span className="search-chat__title-dialogue-name"> - {searchDialogue.dialogName}</span>}
    </div>;
  }

  return <div className="search-chat">
    {
      !loading.includes(getTranslations) && searchDialogue && <>
        <h1 className="search-chat__title">
          <img src={DefaultIcon} alt="" className="search-chat__icon"/>
          {renderBreadcrumbs()}
        </h1>
        <BotChat mode={BotType.Xpedition} dialogueId={searchDialogue.dialogId} title={searchDialogue.dialogName} />
      </>
    }
  </div>;
};
